// extracted by mini-css-extract-plugin
export default {"swatchContainerWrapper":"color-picker_swatchContainerWrapper__nGSVC","swatchContainer":"color-picker_swatchContainer__TzE+T","colorField":"color-picker_colorField__xh8xA"};